import React from 'react';
import { View } from 'styleguide/View';
import AlienAbduction from 'assets/alien-abduction.svg';
import { H2, P2 } from 'styleguide/Texts';
import { Spacing } from 'styleguide/spacing';
import { t } from 'translations/t';

export const FolderNotFoundView = () => {
  return (
    <View
      style={{
        height: 400,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AlienAbduction />
      <H2
        style={{
          textAlign: 'center',
          marginTop: Spacing.md,
          marginBottom: Spacing.md,
        }}
      >
        {t('web.folderDetail.folderNotFound')}
      </H2>
      <P2 style={{ textAlign: 'center', maxWidth: 300 }}>
        {t('web.folderDetail.folderMayNotExists')}
      </P2>
    </View>
  );
};
